module.exports = __webpack_public_path__ + "static/img/已驳回.90dc119c.png";